import {JsonProperty} from 'json-typescript-mapper';
export class ElectricMeterCurrentLoss {
  @JsonProperty('branchId')
  public branchId: number = void 0;
  @JsonProperty('branchName')
  public branchName: string = void 0;
  @JsonProperty('difference')
  public difference: number = void 0;
  @JsonProperty('electricmeterId')
  public electricmeterId: number = void 0;
  @JsonProperty('electricmeterFixedAmount')
  public electricmeterFixedAmount: '0' | '1' = void 0;
  @JsonProperty('electricmeterInternalNumber')
  public electricmeterInternalNumber: string = void 0;
  @JsonProperty('electricmeterLocation')
  public electricmeterLocation: string = void 0;
  @JsonProperty('electricmeterNumber')
  public electricmeterNumber: string = void 0;
  @JsonProperty('marketdateEvasiveDate')
  public marketdateEvasiveDate: string = void 0;
  @JsonProperty('marketdayId')
  public marketdayId: number = void 0;
  @JsonProperty('marketdayName')
  public marketdayName: string = void 0;
  @JsonProperty('marketdayNumber')
  public marketdayNumber: string = void 0;
  @JsonProperty('meterreadingAfterId')
  public meterreadingAfterId: number = void 0;
  @JsonProperty('meterreadingAfterUpdated')
  public meterreadingAfterUpdated: string = void 0;
  @JsonProperty('meterreadingAfterValue')
  public meterreadingAfterValue: number = void 0;
  @JsonProperty('meterreadingBeforeId')
  public meterreadingBeforeId: number = void 0;
  @JsonProperty('meterreadingBeforeUpdated')
  public meterreadingBeforeUpdated: string = void 0;
  @JsonProperty('meterreadingBeforeValue')
  public meterreadingBeforeValue: number = void 0;

  constructor() {
    this.branchId = void 0;
    this.branchName = void 0;
    this.difference = void 0;
    this.electricmeterId = void 0;
    this.electricmeterInternalNumber = void 0;
    this.electricmeterLocation = void 0;
    this.electricmeterNumber = void 0;
    this.marketdateEvasiveDate = void 0;
    this.marketdayId = void 0;
    this.marketdayName = void 0;
    this.marketdayNumber = void 0;
    this.meterreadingAfterId = void 0;
    this.meterreadingAfterUpdated = void 0;
    this.meterreadingAfterValue = void 0;
    this.meterreadingBeforeId = void 0;
    this.meterreadingBeforeUpdated = void 0;
    this.meterreadingBeforeValue = void 0;
    this.electricmeterFixedAmount = void 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/electric-meter-current-loss.ts